import {settings} from "./settings";

export const baseUrl = `${settings.api}/api/v1/`;

export const AppVersion = '2.4.0';
